/**
 * Visibility rules for qualification fields. Both keys are optional extras on the
 * qualification_fields JSON — fields without them behave exactly as before.
 *
 *   patient_types: ['new_patient']            → only shown to that patient type
 *   visible_if: { field_id, values: [...] }   → only shown once the referenced
 *                                               field's answer matches one of values
 */

export function fieldMatchesPatientType(field, patientSelected) {
    const types = field?.patient_types;
    if (!Array.isArray(types) || types.length === 0) return true;
    if (!patientSelected || patientSelected === 'all' || patientSelected === 'new_and_returning_patient') return true;
    return types.includes(patientSelected);
}

export function filterFieldsForPatientType(fields, patientSelected) {
    if (!Array.isArray(fields)) return fields;
    return fields.filter((f) => fieldMatchesPatientType(f, patientSelected));
}

/**
 * @param {Object} field - qualification field, possibly carrying visible_if
 * @param {Object} answers - map of field id -> answer (listDataQuestion)
 * @returns {boolean} true when the field should be shown
 */
export function conditionSatisfied(field, answers) {
    const cond = field?.visible_if;
    if (!cond || cond.field_id == null || !Array.isArray(cond.values) || cond.values.length === 0) return true;

    const answer = answers?.[cond.field_id] ?? answers?.[String(cond.field_id)];
    if (answer === undefined || answer === null) return false;

    const wanted = cond.values.map((v) => String(v).trim().toLowerCase());

    // multi_select answers are stored as a JSON array string — match on any overlap
    if (typeof answer === 'string' && answer.startsWith('[') && answer.endsWith(']')) {
        try {
            const arr = JSON.parse(answer);
            if (Array.isArray(arr)) {
                return arr.some((v) => wanted.includes(String(v).trim().toLowerCase()));
            }
        } catch (_) { /* fall through to plain string match */ }
    }

    // checkbox answers are stored as 1/0 — normalize to yes/no
    let norm;
    if (answer === 1 || answer === '1') norm = 'yes';
    else if (answer === 0 || answer === '0') norm = 'no';
    else norm = String(answer).trim().toLowerCase();

    return wanted.includes(norm);
}
